import { RecorderAgentDevice, RecorderAgentDeviceChannel, RecordingAgentSettings } from '@api';
import { FormItem, Hide, Radio, Space, Switch, Textbox } from '@components';
import React from 'react';
import './AgentConfigurationCard.scss';
import { cloneDeep } from 'lodash';

interface AgentConfigurationCardProps {
	configuration: RecordingAgentSettings;
    uniqueSuffix: string;
    briefMode: boolean;
	onConfigChanged?: (newConfig: RecordingAgentSettings) => void;
}

function AgentConfigurationCard(props: AgentConfigurationCardProps): JSX.Element {

	const { 
        onConfigChanged, 
        uniqueSuffix,
        briefMode
    } = props;

	const config = props.configuration;

    const onChannelNameChange = (deviceId: string, channelNum: number, newName: string) => {
        const newConfig: RecordingAgentSettings = cloneDeep(config);
        const device = newConfig.devices.filter(d => d.id == deviceId)[0];
        device.channels[channelNum].name = newName;
		if (onConfigChanged) {
			onConfigChanged(newConfig);
		}
    }

    const onChannelEnabledChange = (deviceId: string, channelNum: number, enabled: boolean) => {
        const newConfig: RecordingAgentSettings = cloneDeep(config);
        const device = newConfig.devices.filter(d => d.id == deviceId)[0];
        device.channels[channelNum].enabled = enabled;
		if (onConfigChanged) {
			onConfigChanged(newConfig);
		}
    }

    const renderAgentDeviceChannel = (deviceId: string, channel: RecorderAgentDeviceChannel, num: number) => {
        return <div className="agent_config_card__channel" key={num}>
            <FormItem label={`Микрофон ${num+1}`}>
                <Space className="agent_config_card__channel_content">
                    <Textbox value={channel.name} onValueChange={(newName) => onChannelNameChange(deviceId, num, newName)} />
                    <Switch value={channel.enabled} onChange={() => onChannelEnabledChange(deviceId, num, !channel.enabled)} />
                </Space>
            </FormItem>
        </div>
    }

    const onSelectedDeviceChange = (deviceId: string) => {
        const newConfig: RecordingAgentSettings = cloneDeep(config);
        newConfig.selectedDeviceId = deviceId;
		if (onConfigChanged) {
			onConfigChanged(newConfig);
		}
    }

    const renderAgentDevice = (device: RecorderAgentDevice): JSX.Element => {
        return <div key={device.id} className="agent_config_card__device">
            {!briefMode ?
             <div className="agent_config_card__device__id">
                <Radio
                    label={<div>{device.name} <span className='agent_config_card__device__api'>{device.api}</span></div>}
                    radioGroup={`${uniqueSuffix}_agent_device`}
                    boolValue={config.selectedDeviceId == device.id}
                    onValueChange={() => onSelectedDeviceChange(device.id)}
                />
            </div> : null}
            <Hide 
                label="Микрофоны"
                className="agent_config_card__advanced"
                defaultExpanded={!briefMode && device.id == config.selectedDeviceId}>
                {device.channels?.map((c, num) => renderAgentDeviceChannel(device.id, c, num))}
            </Hide>
        </div>
    };

    const selectedDevices =  config && config.devices && config.devices.filter(d => d.id == config.selectedDeviceId);

    const devicesView = briefMode 
        ? selectedDevices && selectedDevices.length && renderAgentDevice(selectedDevices[0])
        : config.devices.map(d => renderAgentDevice(d));


    return <div className="agent_config_card">
			{devicesView}
        </div>
}

const MemoisedAgentConfigurationCard = React.memo(AgentConfigurationCard);

export {MemoisedAgentConfigurationCard as AgentConfigurationCard};
export type {AgentConfigurationCardProps};